import type { IMosaicTocExpanded, ITocActionSetRequestStatus } from "./interface";

/**
 * Stores the current ToC request status.
 *
 * @param state - The current expanded ToC state.
 * @param action - The action containing the latest request status.
 * @returns The updated ToC state with the request status applied.
 */
export const toc_setTocRequestStatus = (
  state: IMosaicTocExpanded,
  action: ITocActionSetRequestStatus,
): IMosaicTocExpanded => ({
  ...state,
  tocRequestStatus: action.tocRequestStatus,
});
